module.exports = __webpack_public_path__ + "static/media/call_u.60d2f4fd.png";